// extracted by mini-css-extract-plugin
export var active = "Header-module--active--31cf9";
export var header = "Header-module--header--1b1d5";